import React from "react";
import WpImage from "./WpImage";

// One copy of the row must be wider than the viewport to keep the loop seamless:
// 20 logos x 174px (120px box + 54px gap) is about 3480px.
const MIN_LOGOS_PER_COPY = 20;

const HeroLogos = ({ label, logos }) => {
    const items = logos?.filter(({ image }) => !!image) || [];

    if (items.length === 0) return null;

    const repeats = Math.ceil(MIN_LOGOS_PER_COPY / items.length);
    const row = Array.from({ length: repeats }).flatMap(() => items);

    return (
        <div className="hero-logos">
            {label && <p className="hero-logos__label">{label}</p>}

            <div className="hero-logos__marquee">
                <div className="hero-logos__track">
                    {[0, 1].map((copyIndex) => (
                        <div
                            className="hero-logos__row"
                            key={copyIndex}
                            aria-hidden={copyIndex === 1 ? "true" : undefined}
                        >
                            {row.map(({ image }, index) => (
                                <div
                                    className="hero-logos__logo"
                                    key={index}
                                    aria-hidden={
                                        index >= items.length
                                            ? "true"
                                            : undefined
                                    }
                                >
                                    <WpImage image={image} />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HeroLogos;
